export const API = 'https://script.google.com/macros/s/AKfycbx2_A96HJU90g-32p1iSsuaO00IjIK1EhmQznBmJPkd4zlWDc9fNLGuEFqzlwQrowCiMA/exec';
